var _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%"
    },
    width: 95,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95 100",
    id: "svg8629344976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 58.334 79.167 L 46.279 44.783 C 40.682 28.817 37.883 20.833 33.334 20.833 C 28.784 20.833 25.986 28.817 20.388 44.783 L 8.335 79.167 M 18.751 50 L 47.917 50 M 91.537 58.08 L 91.537 76.83 M 91.537 58.08 C 91.734 54.65 91.742 52.038 91.33 49.905 C 90.36 44.879 85.107 41.85 80.024 41.233 C 75.159 40.643 71.255 41.896 67.305 47.651 M 91.537 58.08 L 79.69 58.08 C 77.87 58.08 76.034 58.168 74.28 58.655 C 63.56 61.635 64.346 76.668 75.097 78.521 C 76.293 78.731 77.507 78.811 78.72 78.761 C 81.543 78.635 84.148 77.271 86.384 75.542 C 89.002 73.517 91.538 70.69 91.538 66.413 L 91.538 58.08 Z",
    fill: "#000000",
    strokeWidth: "5px",
    stroke: "#FFFCF5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "",
    fillOpacity: 0
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#svg8629344976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/bd.ef4308c334612e98b0c4c9911cc8562f.svg";
export { ForwardRef as ReactComponent };